"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KnownContextTagKeys = exports.KnownSeverityLevel = exports.KnownDataPointType = void 0;
/** Known values of {@link DataPointType} that the service accepts. */
var KnownDataPointType;
(function (KnownDataPointType) {
    KnownDataPointType["Measurement"] = "Measurement";
    KnownDataPointType["Aggregation"] = "Aggregation";
})(KnownDataPointType = exports.KnownDataPointType || (exports.KnownDataPointType = {}));
/** Known values of {@link SeverityLevel} that the service accepts. */
var KnownSeverityLevel;
(function (KnownSeverityLevel) {
    KnownSeverityLevel["Verbose"] = "Verbose";
    KnownSeverityLevel["Information"] = "Information";
    KnownSeverityLevel["Warning"] = "Warning";
    KnownSeverityLevel["Error"] = "Error";
    KnownSeverityLevel["Critical"] = "Critical";
})(KnownSeverityLevel = exports.KnownSeverityLevel || (exports.KnownSeverityLevel = {}));
/** Known values of {@link ContextTagKeys} that the service accepts. */
var KnownContextTagKeys;
(function (KnownContextTagKeys) {
    KnownContextTagKeys["AiApplicationVer"] = "ai.application.ver";
    KnownContextTagKeys["AiDeviceId"] = "ai.device.id";
    KnownContextTagKeys["AiDeviceLocale"] = "ai.device.locale";
    KnownContextTagKeys["AiDeviceModel"] = "ai.device.model";
    KnownContextTagKeys["AiDeviceOemName"] = "ai.device.oemName";
    KnownContextTagKeys["AiDeviceOsVersion"] = "ai.device.osVersion";
    KnownContextTagKeys["AiDeviceType"] = "ai.device.type";
    KnownContextTagKeys["AiLocationIp"] = "ai.location.ip";
    KnownContextTagKeys["AiLocationCountry"] = "ai.location.country";
    KnownContextTagKeys["AiLocationProvince"] = "ai.location.province";
    KnownContextTagKeys["AiLocationCity"] = "ai.location.city";
    KnownContextTagKeys["AiOperationId"] = "ai.operation.id";
    KnownContextTagKeys["AiOperationName"] = "ai.operation.name";
    KnownContextTagKeys["AiOperationParentId"] = "ai.operation.parentId";
    KnownContextTagKeys["AiOperationSyntheticSource"] = "ai.operation.syntheticSource";
    KnownContextTagKeys["AiOperationCorrelationVector"] = "ai.operation.correlationVector";
    KnownContextTagKeys["AiSessionId"] = "ai.session.id";
    KnownContextTagKeys["AiSessionIsFirst"] = "ai.session.isFirst";
    KnownContextTagKeys["AiUserAccountId"] = "ai.user.accountId";
    KnownContextTagKeys["AiUserId"] = "ai.user.id";
    KnownContextTagKeys["AiUserAuthUserId"] = "ai.user.authUserId";
    KnownContextTagKeys["AiCloudRole"] = "ai.cloud.role";
    KnownContextTagKeys["AiCloudRoleVer"] = "ai.cloud.roleVer";
    KnownContextTagKeys["AiCloudRoleInstance"] = "ai.cloud.roleInstance";
    KnownContextTagKeys["AiCloudLocation"] = "ai.cloud.location";
    KnownContextTagKeys["AiInternalSdkVersion"] = "ai.internal.sdkVersion";
    KnownContextTagKeys["AiInternalAgentVersion"] = "ai.internal.agentVersion";
    KnownContextTagKeys["AiInternalNodeName"] = "ai.internal.nodeName";
})(KnownContextTagKeys = exports.KnownContextTagKeys || (exports.KnownContextTagKeys = {}));
//# sourceMappingURL=index.js.map